export default {
  d: "M16,15V1L8,8L16,15zM8,15V1L0,8L8,15z",
  viewBox: "0 0 16 16"
}
